<template>
    <v-app >

      <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
        <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

          <v-container fluid fill-height align-start>
                <v-row >
                    <v-col md="12" lg="12" cols="12">

                        <v-alert
                                :value="alertborrador"
                                color="red"
                                dark
                                dismissible
                                border="top"
                                transition="scale-transition"
                        >
                            Su Juego se borro con éxito.
                        </v-alert>
                        <v-alert
                                :value="alertnuevo"
                                color="primary"
                                dark
                                dismissible
                                border="top"
                                transition="scale-transition"
                        >
                            Su Juego se agrego con éxito.
                        </v-alert>
                        <v-alert
                                :value="alerteditar"
                                color="green"
                                dark
                                dismissible
                                border="top"
                                transition="scale-transition"
                        >
                            Su Juego se edito con éxito.
                        </v-alert>
                      <h1 class="text-h3 text-center" style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Mis Juegos</h1>
<br/>
                      <v-btn color="primary" dark class="mb-2" @click="irpaso1">Nuevo Juego</v-btn>
                      <div>
                        <v-switch label="Ver Como Tabla" v-model="vistatabla"></v-switch>
                      </div>
                      <v-dialog v-model="edialog" max-width="500px">
                        <v-card color="#393E46">
                          <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-text-field v-model="editedItem.nombre" label="Nombre"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <v-textarea v-model="editedItem.descripcion" label="Descripción" ></v-textarea>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="confdialog" max-width="500px">
                        <v-card color="#393E46">
                          <v-card-title>
                            <span class="headline">Configuración</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-switch v-model="editedItem.activo" @click="activaJuego(item)" ></v-switch>
                                </v-col>

                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialogdelete" persistent max-width="350">
                        <v-card color="#393E46">
                          <v-card-title class="headline">Desea eliminar esta Juego?</v-card-title>
                          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" text @click="close">No</v-btn>
                            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>




                      <div v-if="vistatabla===false">
                        <v-row>
                          <v-col cols="12" md="3" sm="12" lg="3"
                                 v-for="evento in Juegos" :key="evento.id"
                          >
                            <v-card color="#2f363e"
                            >
                              <v-card-title>{{evento.nombre}}</v-card-title>
                              <v-card-subtitle>
                                <v-switch v-model="evento.activo" @change="graba(evento)" label="Activo">Activo</v-switch>
                              </v-card-subtitle>
                              <v-card-text>
                                <v-row justify="center">
                                  <v-col lg="6" md="6" sm="12">
                                    <div v-if="evento.foto==''">
                                      <v-img height="200" src="@/assets/sinimagen.jpeg" />
                                    </div>
                                    <div v-else>
                                      <v-img height="200" :src="evento.foto"></v-img>
                                    </div>
                                  </v-col>
                                </v-row>
                                <v-row justify="ce  nter">
                                  <v-col cols="12" lg="12" align="center" >
                                    <h3> {{formatDatee(evento.fechaInicio)}}</h3>
                                  </v-col>
                                </v-row>

                              </v-card-text>
                              <v-card-actions>
                                <v-row>
                                  <v-col>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                    <v-icon

                                        color="primary"
                                        large
                                        class="mr-2"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="editItem(evento)"
                                    >
                                      fas fa-edit
                                    </v-icon>  </template>
                                      <span>Editar</span>
                                    </v-tooltip>
                                  </v-col>
                                  <v-col>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon

                                            color="green"
                                            large
                                            class="mr-2"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="premioItem(evento)"
                                        >
                                          fas fa-award
                                        </v-icon>  </template>
                                      <span>Premios</span>
                                    </v-tooltip>
                                  </v-col>
                                  <v-col> <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">  <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                      class="mr-2"
                                      large
                                      color="error"
                                      @click="deleteItem(evento)"
                                  >
                                    fas fa-minus-circle
                                  </v-icon></template>
                                    <span>Borrar</span>
                                  </v-tooltip> </v-col>



                                </v-row>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </v-row>
                      </div>

                      <div v-else-if="vistatabla===true">
                      <v-data-table
                                :headers="headers"
                                :items="Juegos"
                                sort-by="Juego"
                                sort-desc
                                class="elevation-1"
                                :search="search"
                                :loading="progr"
                                no-data-text="No hay datos disponibles para mostrar."
                                no-results-text="No hay resultados para la búsqueda."
                                loading-text="Cargando... Por favor espere."
                                style="background-color: #393E46;"
                        >
                            <template v-slot:top>
                                <v-toolbar flat >
                                    <v-toolbar-title>Juegos</v-toolbar-title>
                                    <v-progress-circular
                                            indeterminate
                                            v-if="progr == true"
                                            color="primary"
                                    ></v-progress-circular>
                                    <v-divider
                                            class="mx-4"
                                            inset
                                            vertical
                                    ></v-divider>
                                    <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                                    <v-spacer></v-spacer>


                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <v-icon
                                        small
                                        color="blue"
                                        class="mr-2"
                                        @click="editItem(item)"
                                >
                                    fas fa-edit
                                </v-icon>
                                <v-icon
                                        small
                                        color="error"
                                        class="mr-2"
                                        @click="deleteItem(item)"
                                >
                                    fas fa-minus-circle
                                </v-icon>

                            </template>


                            <template v-slot:[`item.activ`]="{ item }">
                                <v-switch v-model="item.activo" @click="activaJuego(item)" ></v-switch>
                            </template>
                          <template v-slot:[`item.fechai`]="{ item }">
                            {{formatDatee(item.fechaInicio)}}
                          </template>
                            <template v-slot:no-data>
                                <v-btn color="primary" @click="dameJuegos">Cargar de Nuevo</v-btn>
                            </template>
                        </v-data-table>
                      </div>

                    </v-col>
                </v-row>
              <leftmenujuegos :abreviado="abreviado" />
            <v-overlay :value="overlay">
              <v-img
                  src="@/assets/loadtunay.gif"

              />
            </v-overlay>
            </v-container>
        </v-main>
      <piepagina/>
    </v-app>
</template>
<script>
    import { mapGetters } from "vuex";
    import axios from 'axios';
    import moment from "moment";
    import piepagina from "@/components/general/piepagina";
    import store from "@/store";
    import firebase from 'firebase/compat/app';
    import Cabecerabaja from "@/components/general/cabecerabaja";
    import Leftmenujuegos from "@/components/general/leftmenujuegos.vue";

    export default {
      title: 'Juegos | Tunay Mi acceso de bolsillo',

      components: {
          Leftmenujuegos,
        Cabecerabaja,
          piepagina
        },
        data: () => ({
          vistatabla: false,
            drawer: null,
            overlay:false,
            progr: true,
          token:'',
            alertborrador: false,
            alertnuevo: false,
            alerteditar: false,
            dialog: false,
            categoriafiesta: 0,
            tipoevento: 0,
          abreviado:'NN',

          steps: 4,
            e1: 1,
            imagen:null,
            edialog: false,
            confdialog: false,
            dialogdelete: false,
            dialogcontactos: false,
            date: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            dialoguploadfooter: false,
            dialoguploadcabecera: false,
            dialoguploadfoto: false,
            menu1: false,
            menu2: false,
            menu3: false,
            modal3: false,
            modal4: false,
            menu4: false,
            time: null,
            time2: null,
            Juegos: [],
            CategoriaJuegos: [],
            TipoJuegos: [],
            eventoId: 0,
            JuegoContactos:[],
            SelectedJuegoContacots:[],
            search: '',
            editedIndex: -1,
            contactoJuegoItem: {
              contactoJuegoId:0,
              contactoDTO:{
                contactoId:0,
                contactoNombre:''
              },
              eventoDTO:{
                eventoId:0,
                eventoNombre:'',
                eventoTag:''
              }
            },
            editedItem: {
              activo: false,
              aforo: 0,
              cabecera: "",
              cliente: {},
              contactoEntitySet: [],
              createdAt: null,
              descripcion: "",
              eventoCategoria: {},
              fechaFinal: "2017-10-21",
              fechaInicio: "2017-10-21",
              flyer: "",
              footer: "",
              foto: "",
              horaFinal: "00:00:00",
              horaInicio: "00:00:00",
              id: 1,
              lat: "",
              listaapp: false,
              lng: "",
              nombre: "",
              promotorcambia: false,
              publicoapp: false,
              qrmail: false,
              tag: "",
              tipoJuego: {},
              ubicacion: "",
              ventapp: false,
            },
            defaultItem: {
              activo: false,
              aforo: 0,
              cabecera: "",
              cliente: {},
              contactoEntitySet: [],
              createdAt: null,
              descripcion: "",
              eventoCategoria: {},
              fechaFinal: "2017-10-21",
              fechaInicio: "2017-10-21",
              flyer: "",
              footer: "",
              foto: "",
              horaFinal: "00:00:00",
              horaInicio: "00:00:00",
              id: 1,
              lat: "",
              listaapp: false,
              lng: "",
              nombre: "",
              promotorcambia: false,
              publicoapp: false,
              qrmail: false,
              tag: "",
              tipoJuego: {},
              ubicacion: "",
              ventapp: false,
            },
            headers: [
                { text: 'Acciones', value: 'action', sortable: false },
                { text: 'Juego', align: 'left',  value: 'nombre'},
                { text: 'Fecha', value: 'fechai' },
                { text: 'Activo', value: 'activ', sortable: false }

            ]
        }),
        mounted (){
          if(this.cliente == null){
            this.$router.push({ name: 'creacliente' });
          }else{
          if (this.cliente.id > 0){
              const auth = firebase.auth()
            this.token = auth.currentUser.auth.currentUser.accessToken;

            this.dameJuegos();
            this.editedItem.fechaInicio = this.formatDate(this.date);
            this.editedItem.fechaFinal = this.formatDate(this.date2);
            this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
          }else{
            this.$router.push({ name: 'creacliente' });
          } }
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
            date () {
                this.editedItem.fechaInicio = this.formatDate(this.date)
            },
            date2 () {
                this.editedItem.fechaFinal = this.formatDate(this.date2)
            },
        },
        methods : {
          formatDatee(value) {
            return moment(value).locale('es-pe').format("DD MMMM YYYY")
          },
          remove (item) {
            const index = this.SelectedJuegoContacots.indexOf(item)
            if (index >= 0) this.SelectedJuegoContacots.splice(index, 1)
          },
            dameJuegos(){
              this.overlay = true;
                this.progr = true;
                let urlJuego = 'juegos/cliente/' + this.cliente.id ;
                axios
                    .get(urlJuego,{
                      headers: {
                        'Authorization': `Bearer ${this.token}`,
                      }
                    })
                    .then(response => {
                        this.Juegos = response.data;
                        this.progr = false;
                        this.alertborrador = false;
                        this.alertnuevo = false;
                        this.alerteditar = false;
                        this.overlay = false;
                    })
                    .catch((error)  => {
                        console.log(error);
                      this.progr = false;
                        this.overlay = false;
                    });
            },
          formatDate (date) {
            return moment(date).locale('es-pe').format("YYYY-MM-DD");
          },
          formatDatree(value) {
            return moment(value).locale('es-pe').format("DD-MM-YYYY")
          },
          irpaso1(){
            this.$router.push({name:'CreaPasoJuego'});
          },
          formatTime (date) {
            let hora = new Date('2020-10-10 '+date)
            return moment(hora).locale('es-pe').format("HH:mm");
          },
            parseDate (date) {
                if (!date) return null

                const [day,month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },




            activaJuego (item) {
                this.editedItem = Object.assign({}, item)
              this.editedItem.fechaInicio = this.formatDatree(this.editedItem.fechaInicio)
              this.editedItem.fechaFinal = this.formatDatree(this.editedItem.fechaFinal)
              var bodyFormData2 = new FormData();
                bodyFormData2.append("data",JSON.stringify(this.editedItem));
                axios
                    .post('juegos/grabar',bodyFormData2,{
                      headers: {
                        'Authorization': `Bearer ${this.token}`,
                      }
                    }).then(response => {
                    console.log(response);
                     })
                    .catch(error => {
                        this.error = "Hubo un error";
                        console.log(error);
                    });
            },
            editItem (item) {
                this.editedIndex = this.Juegos.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.edialog = true
            },

          premioItem(item){
            this.editedIndex = this.Juegos.indexOf(item);
            this.editedItem = Object.assign({}, item)
            store.dispatch("fetchJuego", this.editedItem);
            if(item.juego==="Ruleta"){
            this.$router.push({ name: 'PremiosRuleta', params: { idjuego: item.tag }})
            }
          },

            deleteItem (item) {
                this.editedIndex = this.Juegos.indexOf(item);
                this.dialogdelete = true;
            },
           irZona(item){
             this.editedIndex = this.Juegos.indexOf(item);
             this.editedItem = Object.assign({}, item)
             store.dispatch("fetchJuego", this.editedItem);

             this.$router.push({name:'ZonaJuego'})
           },
          irEntradas(item){
            this.editedIndex = this.Juegos.indexOf(item);
            this.editedItem = Object.assign({}, item)
            store.dispatch("fetchJuego", this.editedItem);
            this.$router.push({name:'TicketJuego'})
          },
            borralo (){
             let idevento = this.Juegos[this.editedIndex].id
                axios
                    .delete('eventos/'+idevento,{
                      headers: {
                        'Authorization': `Bearer ${this.token}`,
                      }
                    })
                    .then(response => {
                        this.dialogdelete = false;
                        this.alertborrador = true;
                        this.Juegos = response.data
                    })
                    .catch(error => {
                        this.error = "Hubo un error";
                        console.log(error);
                    });
            },
            close () {
                this.dialog = false;
                this.edialog = false;
                this.confdialog = false;
                this.dialogdelete = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },
          graba(item){
            var bodyFormData2 = new FormData();
            item.fechaInicio = this.formatDatree(item.fechaInicio)
            item.fechaFinal = this.formatDatree(item.fechaFinal)
            bodyFormData2.append("data",JSON.stringify(item));
            axios
                .post('eventos/grabaevento',bodyFormData2,{
                  headers: {
                    'Authorization': `Bearer ${this.token}`,
                  }
                }).then(response => {
              this.Juegos = response.data
              this.alerteditar = true;

            })
                .catch(error => {
                  this.error = "Hubo un error";
                  console.log(error);
                });
          },
            save () {
              var bodyFormData2 = new FormData();
                if (this.editedIndex > -1) {
                    Object.assign(this.Juegos[this.editedIndex], this.editedItem);
                  this.editedItem.fechaInicio = this.formatDatree(this.editedItem.fechaInicio)
                  this.editedItem.fechaFinal = this.formatDatree(this.editedItem.fechaFinal)
                  this.editedItem.horaInicio = this.formatTime(this.editedItem.horaInicio)
                  this.editedItem.horaFinal = this.formatTime(this.editedItem.horaFinal)
                  bodyFormData2.append("data",JSON.stringify(this.editedItem));

                  axios
                        .post('eventos/grabaevento',bodyFormData2,{
                          headers: {
                            'Authorization': `Bearer ${this.token}`,
                          }
                        }).then(response => {
                        this.Juegos = response.data
                        this.alerteditar = true;

                    })
                        .catch(error => {
                            this.error = "Hubo un error";
                            console.log(error);
                        });
                } else {
                  this.editedItem.fechaInicio = this.formatDatree(this.editedItem.fechaInicio)
                  this.editedItem.fechaFinal = this.formatDatree(this.editedItem.fechaFinal)
                  this.editedItem.horaInicio = this.formatTime(this.editedItem.horaInicio)
                  this.editedItem.horaFinal = this.formatTime(this.editedItem.horaFinal)
                  bodyFormData2.append("data",JSON.stringify(this.editedItem));

                  axios
                        .post('eventos/grabaevento',bodyFormData2,{
                          headers: {
                            'Authorization': `Bearer ${this.token}`,
                          }
                        }).then(response => {
                        this.dameJuegos();
                        this.alertnuevo = true;
                        console.log(response);
                    })
                        .catch(error => {
                            this.error = "Hubo un error";
                            console.log(error);
                        });
                }
                this.close()
            },
        },
        computed: {
            // map `this.user` to `this.$store.getters.user`
            formTitle () {
                return this.editedIndex === -1 ? 'Nueva Juego' : 'Editar Juego'
            },
            computedDateFormatted () {
                return this.formatDate(this.date)
            },
            ...mapGetters({
                user: "user",
                usuario: "usuario",
              cliente: "cliente"
            })
        }
    };
</script>
